// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__yR4Q4","header":"Messages_header__3yb8D"};